import { render, staticRenderFns } from "./PassRemind.html?vue&type=template&id=1d309f3a&scoped=true&"
import script from "./PassRemind.ts?vue&type=script&lang=ts&"
export * from "./PassRemind.ts?vue&type=script&lang=ts&"
import style0 from "./PassRemind.css?vue&type=style&index=0&id=1d309f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d309f3a",
  null
  
)

export default component.exports